import { useEffect } from "preact/hooks";
import { endSession } from "../../platform/session";
import type { PageProps } from "../pageProps";

/** /auth/signout - ends the session (server, tokens, cache, hint cookie) and goes to `/`. */
export const AuthSignOutPage = (_props: PageProps) => {
  useEffect(() => {
    void endSession().finally(() => window.location.replace("/"));
  }, []);
  return (
    <div class="flex justify-center items-center min-h-[60vh] text-center">
      <p class="text-neutral-600 dark:text-neutral-400">Signing out...</p>
    </div>
  );
};
